import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PortalCmctiComponent } from './portal-cmcti/portal-cmcti.component';
import { LoginComponent } from './login/login.component';
import { GerenciadorComponent } from './gerenciador/gerenciador.component';

const routes: Routes = [
  { 
    path: 'portal', 
    component: PortalCmctiComponent 
  },
  { 
    path: '', 
    redirectTo: '/portal', 
    pathMatch: 'full' 
  },
  {
    path: 'gerenciador', 
    component: GerenciadorComponent
  },
  { 
    path: 'login', 
    component: LoginComponent
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts